import React, { useMemo } from 'react'
import PageHeader from './PageHeader'
import Stack from '@mui/material/Stack'
import Box from '@mui/material/Box'
import { Loader } from '@carsys/ui'
import { AutoHeightProvider } from '@cbgms/components/list/AutoHeightProvider'
import { useTopBarHeight } from '../menu/components/TopBar/hooks/use-top-bar-height'
import { useHasStickyHeader } from 'app/layout/use-has-sticky-header'

interface Props extends Partial<React.ComponentProps<typeof PageHeader>> {
  suffixSlot?: JSX.Element
}

export const Layout: React.FC<Props> = ({ title, suffixSlot, children, ...pageHeader }) => {
  const [observedElement, setObservedElement] = React.useState<HTMLDivElement | null>(null)
  const height = useTopBarHeight()
  const { hasStickyHeader } = useHasStickyHeader()
  const stickyHeaderStyling = useMemo(() => {
    if (hasStickyHeader) {
      return {
        position: 'sticky',
        top: height,
        zIndex: 99,
        backgroundColor: '#f0f0f0'
      }
    }
    return {}
  }, [hasStickyHeader, height])

  return (
    <AutoHeightProvider paddingBottom={8} observedElement={observedElement}>
      <Stack direction='column' flex={1} p={0} spacing={1} ref={setObservedElement}>
        <Stack direction='row' justifyContent='space-between' spacing={1} px={1} pt={1} pb={0} sx={stickyHeaderStyling}>
          {title && (
            <Box sx={{ display: 'flex', py: 1 }}>
              <PageHeader title={title} {...pageHeader} />
            </Box>
          )}
          {suffixSlot && <Box>{suffixSlot}</Box>}
        </Stack>
        <Stack sx={{ padding: 1, paddingTop: 0, margin: '0 !important', flexGrow: 1 }}>
          <React.Suspense fallback={<Loader loading fading />}>{children}</React.Suspense>
        </Stack>
      </Stack>
    </AutoHeightProvider>
  )
}
